import React,{Fragment} from 'react';
import { withRouter } from 'react-router';
import { Form,Input,Button,message,Select,Radio } from 'antd';
import LoadingCover from 'components/LoadingCover';
import abortAjaxHoc from 'components/abortAjaxHoc';
import {mixObj} from 'utils/tool';
import style from './LiteForm.module.less';
import {getLabel} from 'components/TipsView/tools';

const FormItem = Form.Item;
const { TextArea } = Input;
const Option = Select.Option;
const defaultVersionType = 1;
const PATTERN = {
    'id': /^[a-zA-Z0-9]*$/,
    'string24': 24,
    'string64': 64,
    'color': /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\,){2}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
};
const LITEV2 = 1;

const defaultImgSize = {
    imgHeight:281,
    width:149
};

const LabelMap = {

    'video_upload_limit':{
        label:'Maximum number of video uploads',
        notice:{
            dec:'The maximum number of times a user can upload a selfie video during a verification process. This configuration is only valid in still mode.'
        }
    },
    'duration_limit':{
        label:'Process timeout duration',
        notice:{
            dec:'The timeout duration of a validation process starts from calling the get_token API.'
        }

    },
    'not_show_index':{
        label:'Is the validation process homepage displayed',
        notice:{
            imgMap:{
                [LITEV2]:require('image/lite/not_show_index.jpg')
            },
            ...defaultImgSize
        }
    },

    'v2_page_theme_color':{
        label:'Verify the theme color of the next and subsequent pages of the verification process',
        notice:{
            dec:'In each page of the process, it is supported to modify the theme color. If not filled in, the default color will be used.',
            img:require('image/lite//v2_page_theme_color.jpg'),
            ...defaultImgSize
        }
    },
    'is_sign_out':{
        label:'Is the exit button displayed',
        notice:{
            dec:'Provide the "Exit Verification" button in the live detection process and click to return to the specified page.',
            imgMap:{
                [LITEV2]:require('image/lite/is_sign_out.jpg')
            },
            ...defaultImgSize
        }

    },
    'wechat_page_title':{
        label:'Browser title name'
    },
    'page_tips_show':{
        label:'Is the page prompt text displayed',
        notice:{
            dec:'A prompt to remind users to confirm their wishes, if checked, will be displayed on various pages of the verification process.',
            img:require('image/lite/page_tips_show.jpg'),
            ...defaultImgSize
        }

    },
    'page_tips_text_color':{
        label:'Page prompt font color',
        notice:{
            dec:'Edit the font color of the copy. If you do not modify or fill in the text, the default color will be used.',
            img:require('image/lite/page_tips_show.jpg'),
            ...defaultImgSize
        }
    },
    'page_tips_bg_color':{
        label:'Page prompt box background color',
        notice:{
            dec:'Edit the background color of the wish prompt box. If it is not modified or filled in, the default color will be used.',
            img:require('image/lite/page_tips_bg_color.jpg'),
            ...defaultImgSize
        }

    },
    'page_tips_text':{
        label:'Page prompt content',
        notice:{
            dec:'The prompt text can be entered in 2 lines. If each line exceeds the page width, an ellipsis will be displayed. You can line-break the copy by pressing Enter. The copy is displayed in the center.',
            img:require('image/lite/page_tips_show.jpg'),
            ...defaultImgSize
        }
    }
};

class LiteForm extends React.Component {

    constructor(props){
        super(props);
        this.id = props.id; //存在id为编辑模式
        this.mode = this.id === undefined ?'create':'edit';
        this.cacheValues = {};
        this.state = {
            type:defaultVersionType,//用于处理类型与表单联动
            isShowMore:false,
            readOnly:false,
            loading:this.mode === 'edit',
            resData:null
        };
    }

    componentDidMount(){
        if(this.mode === 'edit'){
            this.props.abortableAjax('GET','/lite_scene/'+this.id).then(res=>{
                //先设置场景类型
                this.setState({type:1,resData:res.data},()=>{
                    //获取现有表单数据
                    const {setFieldsValue} = this.props.form;
                    if(res.data['ui_type'] === 1){
                        setFieldsValue({
                            page_tips_show:res.data['page_tips_show']
                        },()=>{
                            const {questions,...other} = res.data;
                            //设置其他值
                            this.setNormalFields(other);
                        });
                    }else{
                        this.setNormalFields(res.data);
                    }

                });
            });
        }
    }

    setNormalFields = (data)=>{
        const {getFieldsValue,setFieldsValue} = this.props.form;
        const values = getFieldsValue();

        //取values存在的字段
        const newValues = mixObj(values,data);
        //表单回填
        setFieldsValue(newValues,()=>{
            //设置不在表单字段
            this.setState({
                loading:false
            });
        });
    }

    onSave = ()=>{
        let url = '/lite_scene';
        let type = 'post';
        if(this.id){
            url = '/lite_scene/'+this.id;
            type = 'put';
        }
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                const {...other} = values;
                this.setState({loading:true});
                const params = {
                    ui_type:this.state.type,
                    host_white_list:[],
                    region:'oversea',
                    ...other
                };
                const realParams = {...params};

                this.props.abortableAjax(type,url,realParams).then(()=>{
                    message.success('Successful operation');
                    this.props.history.push('/pages/lite-scenes');
                }).catch(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    getLabel = (key)=>{
        return getLabel(LabelMap,key,1);
    }

    setDisabled(){
        return this.state.readOnly;
    }


    render(){
        const {getFieldDecorator,getFieldValue} = this.props.form;
        const formItemLayout = {
            labelCol: { span: 5 },
            wrapperCol: { span: 19 }
        };
        const {type} = this.state;
        const pageTipsShow = getFieldValue('page_tips_show') === 1;
        return (
            <div style={{marginTop:20}}>
                <LoadingCover spinning={this.state.loading}>
                    <Form layout="vertical">
                        <h1 className={style.title}>base</h1>
                        <div style={{width:700}}>
                            <FormItem label="Scene ID" {...formItemLayout}>
                                {getFieldDecorator('scene_id',{
                                    rules:[{
                                        required: true,
                                        message: 'Scenes ID can not be empty'
                                    }, {
                                        max: 64,
                                        message: 'Scenes ID cannot exceed 64 characters'
                                    }, {
                                        pattern: PATTERN.id,
                                        message: 'Scenes ID can only contain English and numbers'
                                    }]
                                })(
                                    <Input
                                        placeholder='The scene id must be unique and cannot be modified after the scene is created.'
                                        disabled={this.mode === 'edit'}
                                    />
                                )}
                            </FormItem>
                            <FormItem label="Scenes Name" {...formItemLayout}>
                                {getFieldDecorator('scene_name',{
                                    rules: [{
                                        required: true,
                                        message: 'not nullable'
                                    }, {
                                        max: PATTERN.string64,
                                        message: 'Cannot be greater than 64 characters'
                                    }]
                                })(
                                    <Input placeholder="Cannot be greater than 64 characters" disabled={this.setDisabled('scene_name')}/>
                                )}
                            </FormItem>
                            <FormItem label="Scenes Describe" {...formItemLayout}>
                                {getFieldDecorator('scene_description',{
                                    initialValue:'',
                                    rules:[
                                        {
                                            max: PATTERN.string64,
                                            message: 'Cannot be greater than 64 characters'
                                        }
                                    ]
                                })(
                                    <Input placeholder="Cannot be greater than 64 characters" disabled={this.setDisabled('scene_description')}/>
                                )}
                            </FormItem>
                        </div>
                        <div className={style.line}></div>
                        <h1 className={style.title}>config</h1>
                        <div style={{width:424}}>

                            <FormItem colon={false} label={this.getLabel('video_upload_limit')} >
                                {getFieldDecorator('video_upload_limit',{
                                    initialValue:5
                                })(
                                    <Select>
                                        {(()=>{
                                            const options = [];
                                            for (let i = 1; i <= 5; i++) {
                                                options.push(<Option value={i} key={i}>{i}</Option>);
                                            }
                                            return options;
                                        })()}
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem colon={false} label={this.getLabel('duration_limit')} >
                                {getFieldDecorator('duration_limit',{
                                    initialValue:60
                                })(
                                    <Select>
                                        <Option value={5}>5 minutes</Option>
                                        <Option value={10}>10 minutes</Option>
                                        <Option value={15}>15 minutes</Option>
                                        <Option value={30}>30 minutes</Option>
                                        <Option value={60}>60 minutes</Option>
                                    </Select>
                                )}
                            </FormItem>

                            <FormItem colon={false} label={this.getLabel('not_show_index')} >
                                {getFieldDecorator('not_show_index',{
                                    initialValue:0
                                })(
                                    <Radio.Group>
                                        <Radio value={0}>display</Radio>
                                        <Radio value={1}>hide</Radio>
                                    </Radio.Group>
                                )}
                            </FormItem>
                            {/* lite v2特有 */}
                            {type === LITEV2 && <Fragment>
                                <FormItem colon={false} label={this.getLabel('v2_page_theme_color')} >
                                    {getFieldDecorator('v2_page_theme_color',{
                                        rules: [{
                                            pattern: PATTERN.color,
                                            message: 'The title text color does not meet the RGB format requirements'
                                        }],
                                        initialValue: '83,122,229'
                                    })(
                                        <Input placeholder='Split RGB with comma'/>
                                    )}
                                </FormItem>
                                <FormItem colon={false} label={this.getLabel('is_sign_out')} >
                                    {getFieldDecorator('is_sign_out',{
                                        initialValue: 1
                                    })(
                                        <Radio.Group>
                                            <Radio value={1}>display</Radio>
                                            <Radio value={0}>hide</Radio>
                                        </Radio.Group>
                                    )}
                                </FormItem>
                            </Fragment>}
                            {/* lite v2特有结束 */}
                            <FormItem colon={false} label={this.getLabel('wechat_page_title')} >
                                {getFieldDecorator('wechat_page_title',{
                                    rules: [{
                                        max: PATTERN.string24,
                                        message: 'Cannot be greater than 24 characters'
                                    }],
                                    initialValue: ''
                                })(
                                    <Input placeholder='Cannot be greater than 24 characters'/>
                                )}
                            </FormItem>

                            {/* lite v2特有 */}
                            {type === LITEV2 && <Fragment>
                                <FormItem colon={false} label={this.getLabel('page_tips_show')} >
                                    {getFieldDecorator('page_tips_show',{
                                        initialValue: 0
                                    })(
                                        <Radio.Group>
                                            <Radio value={1}>display</Radio>
                                            <Radio value={0}>hide</Radio>
                                        </Radio.Group>
                                    )}
                                </FormItem>
                                {pageTipsShow && <div className={style.subForm}>
                                    <FormItem colon={false} label={this.getLabel('page_tips_text_color')} >
                                        {getFieldDecorator('page_tips_text_color',{
                                            initialValue: '255,142,39',
                                            rules: [{
                                                pattern: PATTERN.color,
                                                message: 'The title text color does not meet the RGB format requirements'
                                            }]
                                        })(
                                            <Input placeholder='Split RGB with comma'/>
                                        )}
                                    </FormItem>
                                    <FormItem colon={false} label={this.getLabel('page_tips_bg_color')} >
                                        {getFieldDecorator('page_tips_bg_color',{
                                            initialValue: '255,244,230',
                                            rules: [{
                                                pattern: PATTERN.color,
                                                message: 'Does not meet RGB format requirements'
                                            }]
                                        })(
                                            <Input placeholder='Split RGB with comma'/>
                                        )}
                                    </FormItem>

                                    <FormItem colon={false} label={this.getLabel('page_tips_text')} >
                                        {getFieldDecorator('page_tips_text',{
                                            initialValue: '',
                                            rules:[
                                                {
                                                    required:true,
                                                    message: 'Page prompt content'
                                                },{
                                                    validator:(rule, value, callback)=>{
                                                    //分割换行
                                                        const testArray = value.split('\n');
                                                        if(testArray.length>2){
                                                            callback('Maximum input allowed is 2 lines');
                                                        }
                                                        const maxLength = 80;
                                                        let textCount = 0;
                                                        for(let i=0;i<testArray.length;i++){
                                                            textCount = textCount + testArray[i].length;
                                                        }
                                                        if(textCount>maxLength){
                                                            callback(`recommended within ${maxLength} characters`);
                                                        }
                                                        callback();
                                                    }
                                                }
                                            ]
                                        })(
                                            <TextArea autosize={{minRows: 2, maxRows: 2}}/>
                                        )}
                                    </FormItem>
                                </div>}
                            </Fragment>}
                        </div>

                        {/* lite v2特有结束 */}

                    </Form>
                    <div style={{marginTop:'64px'}}>
                        {!this.state.readOnly && <Button type="primary" style={{marginRight:24}} onClick={this.onSave}>Save</Button>}
                        <Button href="/pages/lite-scenes">Back</Button>
                    </div>

                </LoadingCover>
            </div>
        );

    }
}

export default Form.create()(abortAjaxHoc(withRouter(LiteForm)));



// WEBPACK FOOTER //
// ./src/pages/LiteScenes/LiteForm.js